import axios from "axios";
import {
  baseURL,
  ServiceURL,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  OTP_REQUEST_SUCCESS,
  OTP_REQUEST_FAILURE,
} from "../actions/type";

/**
 * @param {string} mobile -
 */
export const getOtpAction = (mobile) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const payload = {
    uid: 0,
    mobile: mobile,
    eventId: "E_LOGINOTP",
  };

  try {
    const res = await axios.post(
      `${ServiceURL}/api/ElectionNotification/sendotp`,
      payload,
      config
    );

    dispatch({ type: OTP_REQUEST_SUCCESS });

    return {
      success: true,
      message: res.data.message || "OTP sent successfully!",
    };
  } catch (err) {
    const errorMessage =
      err.response?.data?.message || "Failed to send OTP. Please try again.";

    dispatch({
      type: OTP_REQUEST_FAILURE,
      payload: errorMessage,
    });

    return { success: false, message: errorMessage };
  }
};

// export const handleLoginAction = (mobile, otp) => async (dispatch) => {
//   const config = {
//     headers: {
//       "Content-Type": "application/json",
//     },
//   };

//   const payload = { mobile, otp };

//   try {
//     const res = await axios.post(`${baseURL}/api/users/login`, payload, config);

//     dispatch({
//       type: LOGIN_SUCCESS,
//       payload: res.data,
//     });

//     return { success: true, role: res.data.role };
//   } catch (err) {
//     const errorMessage =
//       err.response?.data?.message || "Invalid credentials or server error.";

//     dispatch({
//       type: LOGIN_FAILURE,
//       payload: errorMessage,
//     });

//     return { success: false, message: errorMessage };
//   }
// };

// export const logout = () => (dispatch) => {
//   dispatch({ type: LOGOUT });
// };
export const handleLoginAction = (mobile, otp) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const payload = { mobile, otp };

  try {
    const res = await axios.post(`${baseURL}/api/users/login1`, payload, config);

    // 👉 Save token in localStorage
    if (res.data.token) {
      console.log(res.data.token)
      localStorage.setItem("token", res.data.token);
            localStorage.setItem("id", res.data.id);

    }

    dispatch({
      type: LOGIN_SUCCESS,
      payload: res.data,
    });

    return { success: true, role: res.data.role };
  } catch (err) {
    const errorMessage =
      err.response?.data?.message || "Invalid credentials or server error.";

    dispatch({
      type: LOGIN_FAILURE,
      payload: errorMessage,
    });

    return { success: false, message: errorMessage };
  }
};
